<template>
  <footer class="t-footer" :style="cssVariables">
    <span class='signature' v-html="$config.strings['footer-signature']" />
    <WoliLogo ref="logo" class="logo"/>
  </footer>
</template>

<script>
import WoliLogo from '@/assets/WOLI-LOGO.svg'
export default {
  name: 't-footer',
  props: {
    backgroundColor: {
      type: String,
      default: 'var(--surface)'
    },
    color: {
      type: String,
      default: 'var(--on-surface)'
    },
    logoColor: {
      type: String,
      default: undefined
    }
  },
  components: { WoliLogo },
  computed: {
    cssVariables () {
      return {
        '--background-color': this.backgroundColor,
        '--text-color': this.color,
        '--logo-color': this.logoColor
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.t-footer {
  @include container-element;
  background-color: var(--background-color);
  color: var(--text-color);
  width: 100%;
  height: 92px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: center;
  padding-top: 26px;
  padding-bottom: 26px;

  @include for-size(tablet-portrait-up) {
    flex-flow: row nowrap;
  }

  .signature {
    justify-self: flex-start;
  }

  .logo {
    .blue{
      fill: var(--logo-color,  $blue-woli-color);
    }
    .red{
      fill: var(--logo-color, $red-woli-color);
    }
  }
}
</style>
